import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/tabon/Logo";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        setUser(data);
        toast.success(`Welcome ${data.name}`);
        // clean URL fragment
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: data } });
      } catch (err) {
        toast.error(formatError(err));
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="flex flex-col items-center gap-4">
        <Logo size="lg" />
        <div className="text-[#A0A0A0] text-sm animate-pulse">Signing you in…</div>
      </div>
    </div>
  );
}
